import { TourneeSiteEdition } from './tournee-site-edition.model';
import { OrganismeEdition } from './organisme-edition.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class TourneeEdition {
    static jsonMap = {
        date: { key: 'date', optional: true, default: '' },
        numero: { key: 'numero', optional: true, default: '' },
        sites: { key: 'sites', converter: new (ArrayClassConverterFactory.build(TourneeSiteEdition))(), optional: true },
        organisme: { key: 'organisme', converter: new (ClassConverterFactory.build(OrganismeEdition))(), optional: true }
    };

    date: string;
    numero: string;
    sites: TourneeSiteEdition[];
    organisme: OrganismeEdition;

    // Données non mappées
    responsable: string;
    idResponsable: number;
}
